import React from "react";
import { DialogActions, Button, CircularProgress } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";

/**
 * Standard modal footer: an optional red Delete button (trash icon) on the
 * left, a blue Save button (save icon) on the right. No Cancel button —
 * modals close via the X in ModalDialogTitle.
 *
 * @param {Function} props.onSave - Required. Save/submit handler.
 * @param {boolean} [props.saving] - Shows a spinner on Save and disables both buttons.
 * @param {string} [props.saveLabel] - Defaults to "Save".
 * @param {boolean} [props.saveDisabled] - Disable Save without a saving spinner (e.g. validation).
 * @param {Function} [props.onDelete] - If provided, renders the Delete button on the left.
 * @param {boolean} [props.deleting] - Shows a spinner on Delete and disables both buttons.
 */
const ModalActions = ({
  onSave,
  saving = false,
  saveLabel = "Save",
  saveDisabled = false,
  onDelete,
  deleting = false,
}) => (
  <DialogActions
    sx={{
      justifyContent: onDelete ? "space-between" : "flex-end",
      px: 3,
      pb: 2,
    }}
  >
    {onDelete && (
      <Button
        onClick={onDelete}
        color="error"
        variant="contained"
        startIcon={
          deleting ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <DeleteIcon />
          )
        }
        disabled={deleting || saving}
      >
        Delete
      </Button>
    )}
    <Button
      onClick={onSave}
      color="primary"
      variant="contained"
      startIcon={
        saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />
      }
      disabled={saving || deleting || saveDisabled}
    >
      {saveLabel}
    </Button>
  </DialogActions>
);

export default ModalActions;
